const getTextByCount = ({ count, one, two, other }) => {
  const countText     = `${count}`
  const countLastChar = countText[countText.length - 1]
  const text          = countLastChar === '1'
    ? one
    : [ '2', '3', '4' ].includes(countLastChar)
      ? two
      : other

  return text
}


export default getTextByCount
